/* ==============================================================================================
 * DEBOUNCE UTIL
 * ============================================================================================== */

var Sushi;

(function (Sushi) {
	"use strict";

	/**
	 * @param {function} func
	 * @param {number} wait
	 * @return {function}
	 */
	Sushi.Util.debounce = function (func, wait) {
		var timer = null;

		return function () {
			clearTimeout(timer);
			timer = setTimeout(func, wait);
		};
	};

})(Sushi || (Sushi = {}));
